<template>
    <div>
        <div class="complete_loader"  v-if="type == 'complete'">
            <img src="../../../../static/website/images/gini.gif" alt="Gini Health" width="80">
        </div>
        <div class="complete_loader chartLoader"  v-if="type == 'chart'">
            <div class="chartLoader">
                <div class="hm-spinner mb-3"></div>
                <span>Please wait while data loading.</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'LOADER',
        data() {
            return { }
        },
        props:{
            'type': {
                default: 'complete',
            },
            'colspan' : {
                default: '',
            },
            'page' : {
                default: '',
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/shared/loader.vue